import { client } from './client';
import { BASE_URL } from '../config';

const normalizeTemplateResponse = (response) => {
  const data = response?.data ?? response;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.templates)) return data.templates;
  if (data?.template) return data.template;
  return data;
};

export const listEditorTemplates = async () => {
  const response = await client.get(`${BASE_URL}/template`);
  const templates = normalizeTemplateResponse(response);
  return Array.isArray(templates) ? templates : [];
};

export const createEditorTemplate = async (payload) => {
  const response = await client.post(`${BASE_URL}/template/store`, payload);
  return normalizeTemplateResponse(response);
};

export const deleteEditorTemplate = async (template) => {
  const id = template?.id || template;
  const response = await client.delete(`${BASE_URL}/template/${encodeURIComponent(id)}/delete`);
  return normalizeTemplateResponse(response);
};

export const uploadEditorTemplateMedia = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const response = await client.post(`${BASE_URL}/template/media`, formData);
  const data = response?.data ?? response;
  const media = data?.media ?? data?.data?.media ?? data?.data ?? data;
  if (!media || typeof media !== 'object') return media;
  const filename = media.filename || media.id;
  const src = filename ? `${BASE_URL}/template/media/${encodeURIComponent(filename)}` : media.src;
  return {
    ...media,
    src,
    url: src,
  };
};
